import { gql } from "@apollo/client";

// What the review would ask about one person: the competencies and
// responsibilities of their roles, and their goals. The preview keeps the
// goals due in the review period, as the review does, so it needs each due
// date rather than the API's date filter, which keeps goals that only overlap.
// An ongoing review counts its period from the person's start date.
const ReviewPreviewRoleFragment = gql`
  fragment ReviewPreviewRole on CareerTrackRoleNode {
    id
    title
    competencies {
      edges {
        node {
          id
          title
          description
          criteria {
            edges {
              node {
                id
                content
              }
            }
          }
        }
      }
    }
    responsibilities {
      edges {
        node {
          id
          content
        }
      }
    }
  }
`;

export default gql`
  ${ReviewPreviewRoleFragment}
  query getReviewPreviewPersonQuery($userId: Int!, $goalStates: [GoalState]) {
    user(userId: $userId) {
      id
      name
      organizationSpecificInfo {
        startDate
      }
      currentRoles {
        ...ReviewPreviewRole
        nextRole {
          ...ReviewPreviewRole
        }
      }
      ownedGoals(goalStates: $goalStates) {
        edges {
          node {
            id
            title
            ... on GoalArtifactNode {
              dueDate
            }
          }
        }
      }
    }
  }
`;
